// extracted by mini-css-extract-plugin
export var avatarContainer = "_fk-0";
export var gray = "_fk-f";
export var green = "_fk-c";
export var icon = "_fk-9";
export var image = "_fk-1";
export var lg = "_fk-6";
export var md = "_fk-5";
export var presenceDot = "_fk-b";
export var red = "_fk-d";
export var sm = "_fk-4";
export var status = "_fk-a";
export var xl = "_fk-7";
export var xs = "_fk-3";
export var xxl = "_fk-8";
export var xxs = "_fk-2";
export var yellow = "_fk-e";